/**
 * @author Mau de Pallares
 * @company Erillam Healthcare
 * @version 2.0
 */
 import PRM from "@/core/PermissionConstants";

export default {
  path: "/app/psicologia/historial-consultas",
  name: "PSYCHOLOGY_HISTORY",
  component: () => import("@/app/views/crud/CrudView.vue"),
  meta: {
    service: () => import("@/app/services/PsychologyHistorialService"),
    table: () =>  import("@/app/components/psychology/historial/PsychologyHistorialTable"),
    form: () =>  import("@/app/components/psychology/historial/PsychologyHistorialForm"),
    header: {
      icono: "mdi-brain",
      texto: "Historial de consultas | Psicología",
      textNew: "Atender Consulta | Psicología",
      textEdit: "Editar Consulta | Psicología",
      textView: "Visualizar consulta | Psicología"
    },
     prm: PRM.MODULE_PSYCHOLOGY_HISTORIC,
    requireAuth: true,
    filterDate: true,
    hideButtonAdd: true,
    filterModality: true,
    cancelationModal: true,
    generatePDFModal: true,
    labelDate: "Seleccione fecha",
    namePDF: "Psicología"
  },
};
